import { RadioTileGroup } from 'components/shared/RadioTileGroup'
import { VariantSelectorProps } from './VariantSelector.types'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import { useResolutions } from 'store/resolutions'

export const VariantSelector = ({
    variants,
    value,
    onVariantSelect,
}: VariantSelectorProps) => {
    const { isMobile } = useResolutions()
    const { formatMessage } = useIntl()

    return (
        <Box width="100%" gap={[8, 16]}>
            <Text variant="heading5" color="grayscale_900">
                <FormattedMessage
                    id="upsells.wellness.choose_variant"
                    defaultMessage="Wybierz wariant"
                />
            </Text>
            <RadioTileGroup
                value={value}
                columns={isMobile ? 2 : 3}
                onChange={onVariantSelect}
                data-testid="spa-variant"
            >
                {variants.map(({ productSpaTreatmentId, duration, price }) => {
                    if (
                        !productSpaTreatmentId ||
                        (duration === undefined && price === undefined)
                    )
                        return <></>

                    return (
                        <RadioTileGroup.SimpleItem
                            key={productSpaTreatmentId}
                            id={`${productSpaTreatmentId}`}
                            value={`${productSpaTreatmentId}`}
                            label={formatMessage(
                                {
                                    id: 'global.units.minutes_abbreviation',
                                    defaultMessage: '{number} min',
                                },
                                {
                                    number: duration,
                                }
                            )}
                            price={price}
                        />
                    )
                })}
            </RadioTileGroup>
        </Box>
    )
}
